export default __webpack_public_path__ + "static/media/hero.036d1a6b.webp";